import { Calendar, ClipboardCheck, Users } from 'lucide-react'
import { Link } from 'react-router-dom'
import { StatusBadge } from '@/components/training/StatusBadge'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { useSubordinateEnrollments } from '@/hooks/use-training-enrollments'
import { hasFollowUpSheet } from '@/lib/skill-check'
import { useTenantPath } from '@/lib/tenant'

export default function SubordinateEnrollmentsPage() {
  const tp = useTenantPath()
  const { data, isLoading } = useSubordinateEnrollments()
  const enrollments = Array.isArray(data) ? data : []

  if (isLoading) {
    return (
      <div className="space-y-6">
        <h1 className="text-2xl font-bold">配下メンバー受講状況</h1>
        <Skeleton className="h-64" />
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-2">
        <Users className="h-6 w-6" />
        <h1 className="text-2xl font-bold">配下メンバー受講状況</h1>
      </div>

      {enrollments.length === 0 ? (
        <Card>
          <CardContent className="text-center py-12">
            <p className="text-muted-foreground">配下メンバーの受講情報はありません</p>
          </CardContent>
        </Card>
      ) : (
        <Card>
          <CardHeader>
            <CardTitle className="text-base">受講一覧</CardTitle>
          </CardHeader>
          <CardContent>
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>メンバー</TableHead>
                  <TableHead>研修名</TableHead>
                  <TableHead>ステータス</TableHead>
                  <TableHead>申込日</TableHead>
                  <TableHead className="text-right">スキルチェック</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {enrollments.map((e: any) => (
                  <TableRow key={e.id}>
                    <TableCell className="font-medium">
                      {e.userName ?? e.user?.name ?? '-'}
                    </TableCell>
                    <TableCell>{e.trainingTitle ?? e.training?.title ?? '-'}</TableCell>
                    <TableCell>
                      <StatusBadge type="enrollment" status={e.status} />
                    </TableCell>
                    <TableCell>
                      {e.enrolledAt ? (
                        <div className="flex items-center gap-1 text-sm">
                          <Calendar className="h-3.5 w-3.5" />
                          {new Date(e.enrolledAt).toLocaleDateString('ja-JP')}
                        </div>
                      ) : (
                        '-'
                      )}
                    </TableCell>
                    <TableCell className="text-right">
                      {hasFollowUpSheet(e.status) && (
                        <Link to={tp(`/follow-ups/${e.id}`)}>
                          <Button variant="outline" size="sm">
                            <ClipboardCheck className="mr-1 h-3.5 w-3.5" />
                            評価
                          </Button>
                        </Link>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </CardContent>
        </Card>
      )}
    </div>
  )
}
